import { useCallback, useMemo } from 'react';
import type { MutableRefObject } from 'react';
import { createAdminHttp } from '../http.js';
import { AdminSessionLifecycle, withSessionRequests } from '../session-lifecycle.js';
import type { AdminSession } from '../types.js';

export function useAdminHttp(baseUrl: string, sessionRef: MutableRefObject<AdminSession | undefined>, lifecycle: AdminSessionLifecycle) {
  const rawPlatformHttp = useMemo(() => createAdminHttp({ baseUrl, getAccessToken: () => sessionRef.current?.accessToken }), [baseUrl, sessionRef]);
  const rawTenantHttp = useMemo(() => createAdminHttp({ baseUrl, getAccessToken: () => sessionRef.current?.tenantContext?.accessToken }), [baseUrl, sessionRef]);
  const renewSession = useCallback(() => lifecycle.renew(rawPlatformHttp), [lifecycle, rawPlatformHttp]);
  const platformHttp = useMemo(() => withSessionRequests(rawPlatformHttp, lifecycle), [rawPlatformHttp, lifecycle]);
  const tenantHttp = useMemo(() => withSessionRequests(rawTenantHttp, lifecycle, true), [rawTenantHttp, lifecycle]);
  return { rawPlatformHttp, rawTenantHttp, platformHttp, tenantHttp, renewSession };
}
